module.exports = __webpack_public_path__ + "img/empty-music.35106f45.svg";